/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import"./gx/operatorDifference.js";import"./support/apiConverter.js";export{e as execute,a as executeMany,s as supportsCurves}from"../../chunks/differenceOperator.js";
